import { render } from "./Community.vue?vue&type=template&id=227c925c&scoped=true"
import script from "./Community.vue?vue&type=script&lang=js"
export * from "./Community.vue?vue&type=script&lang=js"

import "./Community.vue?vue&type=style&index=0&id=227c925c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-227c925c"

export default script